import Reveal from "@/components/Reveal";
import { useContent } from "@/context/ContentContext";

const DEFAULT_SECTIONS = [
  { title: "Orders & payment", body: "All orders placed on this website are confirmed once we verify stock and share a secure payment link with you on your registered phone number or email. Your order is reserved for you and dispatched after payment is completed. Prices listed are in Indian Rupees (₹) and include applicable taxes unless stated otherwise." },
  { title: "Handmade variations", body: "Every Riaas Collective piece is individually handmade. Slight variations in glaze tone, texture, size and form are natural and are part of the character of handmade ceramics — they are not considered defects." },
  { title: "Pricing & availability", body: "We work in small batches, so stock is limited and pieces may sell out. Prices and offers (including coupon codes) may change without prior notice. The price confirmed in your order summary is final for that order." },
  { title: "Shipping", body: "We ship across India in secure, crushproof packaging. Standard insured delivery takes 4–7 business days; priority dispatch takes 2–3 business days. Shipping is free on orders above ₹2,500 (after discounts). Delivery timelines are estimates and may vary by location." },
  { title: "Use of this website", body: "By using this website you agree to provide accurate contact and delivery information. All content on this site — product photography, text and branding — belongs to Riaas Collective and may not be reused without permission." },
  { title: "Contact", body: "For any questions about your order, reach out to us through the contact details shared in your order confirmation. We're happy to help." },
];

const Terms = () => {
  const { c } = useContent();
  const sections = c("terms_sections", DEFAULT_SECTIONS);
  return (
    <div className="mx-auto max-w-3xl px-5 pb-24 pt-32 sm:px-8" data-testid="terms-page">
      <Reveal>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.28em] text-terra">The fine print</p>
        <h1 className="mt-3 font-serif text-3xl tracking-tight text-espresso sm:text-4xl">Terms &amp; Conditions</h1>
        <p className="mt-4 text-sm leading-relaxed text-clay/70">{c("terms_intro", "Welcome to Riaas Collective. By shopping with us, you agree to the terms below.")}</p>
      </Reveal>
      <div className="mt-10 space-y-4">
        {sections.map((s, i) => (
          <Reveal key={i} delay={Math.min(i * 0.05, 0.25)}>
            <div className="rounded-2xl border border-linen bg-white p-6">
              <h2 className="font-serif text-lg text-espresso">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-clay/70">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default Terms;
